import LegalSection from "@/pages/legal/components/LegalSection";

export default function CommunityPage() {
  return (
    <>
      <h1 className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
        Normas de la Comunidad
      </h1>
      <p className="mt-2 text-sm text-foreground-500">
        Última actualización: 10 de septiembre de 2026
      </p>
      <p className="mt-4 text-sm leading-7 text-foreground-700 md:text-[15px] md:leading-8">
        Estas normas definen los principios de convivencia que rigen VendeYa.
        Queremos que la plataforma sea un espacio seguro, transparente y
        respetuoso para compradores y vendedores. Al usar el servicio te
        comprometes a cumplirlas.
      </p>

      <div className="mt-8">
        <LegalSection title="1. Respeto y convivencia">
          <p>
            Trata a los demás usuarios con respeto y cortesía. No toleramos el
            acoso, las amenazas, el lenguaje ofensivo ni cualquier conducta
            discriminatoria por motivos de origen, género, orientación, religión,
            discapacidad o cualquier otra condición.
          </p>
          <p>
            La comunicación entre compradores y vendedores debe mantenerse dentro
            de los canales de la plataforma y centrarse en la transacción, evitando
            mensajes no solicitados o de carácter comercial ajeno al anuncio.
          </p>
        </LegalSection>

        <LegalSection title="2. Prohibición de artículos ilegales">
          <p>
            Está terminantemente prohibida la publicación, venta o promoción de:
          </p>
          <ul className="list-disc space-y-2 pl-5">
            <li>Armas, municiones o materiales peligrosos.</li>
            <li>Sustancias ilegales o artículos relacionados con su consumo.</li>
            <li>Productos robados, falsificados o que infrinjan derechos de autor.</li>
            <li>Materiales que inciten a la violencia, el odio o actividades ilegales.</li>
            <li>Animales vivos o especies protegidas sin la autorización pertinente.</li>
          </ul>
        </LegalSection>

        <LegalSection title="3. Transparencia y veracidad">
          <p>
            Publica información veraz y completa sobre tus artículos: descripción
            real, estado, precio y fotografías del producto. Evita tácticas
            engañosas, como imágenes que no correspondan al artículo o precios que
            no reflejen el valor real de la oferta.
          </p>
          <p>
            No crees cuentas falsas, no manipules valoraciones ni utilices
            identidades de terceros. La confianza es la base de nuestra comunidad.
          </p>
        </LegalSection>

        <LegalSection title="4. Seguridad en las transacciones">
          <p>
            Reúnete en lugares seguros, verifica el artículo antes de pagar y
            desconfía de ofertas que parezcan demasiado buenas para ser ciertas.
            No compartas datos sensibles como contraseñas o información bancaria
            fuera de los canales oficiales.
          </p>
          <p>
            Denuncia cualquier comportamiento sospechoso a través de las
            herramientas de reporte para que nuestro equipo pueda actuar con
            rapidez.
          </p>
        </LegalSection>

        <LegalSection title="5. Consecuencias del incumplimiento">
          <p>
            El incumplimiento de estas normas podrá dar lugar a la retirada de
            anuncios, la suspensión temporal de la cuenta o, en los casos más
            graves, la cancelación definitiva y la notificación a las autoridades
            competentes cuando la situación lo requiera.
          </p>
          <p>
            Nuestro equipo de moderación revisa los reportes de la comunidad y
            aplica las medidas de forma proporcional a la gravedad y reincidencia
            de la conducta.
          </p>
        </LegalSection>
      </div>
    </>
  );
}